import React, { Component } from 'react'
import { checkTranslation, isWhite, translate } from '../../utils/useful'
import importedIcons from '../inputs/icons'

export default class ChangeStage extends Component {

    state = {
        available: [],
        _id: ''
    }

    componentDidMount() {
        if (this.props.data && this.props.data['**stage']) {
            this.init()
        }
    }

    init = () => {

        let _id = this.props.data._id

        this.setState({ _id })
        if (this.props.data['**stage']) {
            // let stages = JSON.parse(JSON.stringify(this.props.data['**stage'].information?.workflow?.flow?.stageMap))
            let stagesToShow = JSON.parse(JSON.stringify(this.props.data['**stage'].information?.workflow?.stages))
            // let current = [this.props.data['**stage']?.value?.stage?.id]
            // let available = []
            // this.setStages(stages, stagesToShow, current, available, (cb) => {
            this.setState({ available: stagesToShow })
        }
        // this.setState({ available })
        // })
    }

    // setStages = (stages, stagesToShow, current, available, cb) => {
    //     let newCurrent = []
    //     for (let x = 0; x < current.length; x++) {
    //         const crnt = current[x];
    //         for (let i = 0; i < stagesToShow.length; i++) {
    //             const element = stagesToShow[i];
    //             if (element.id == crnt) {
    //                 available.push(element)
    //             }
    //         }
    //         for (let i = 0; i < stages.length; i++) {
    //             const element = stages[i];
    //             if (element.src == crnt) {
    //                 newCurrent.push(element.dest)
    //             }
    //         }
    //     }
    //     if (newCurrent.length > 0) {
    //         this.setStages(stages, stagesToShow, newCurrent, available, cb)
    //     } else {
    //         cb()
    //     }
    // }

    changeRecordStage = (stage) => {
        this.props.changeRecordStage(stage)
    }




    render() {
        // console.log(this.props.data)
        return (
            <div>
                <div className="pb-1">
                    <button className="flexc w-100 hover-gray-no-filter p-2 br-10" onClick={this.props.lastPage}  >
                        <img width={18} src={importedIcons.arrowLeft} className="rtl-button" />
                        <p className="font-size-13 weight-500 mld-2 main-c3 text-start">  {translate("Change Stage")}  </p>
                    </button>
                </div>
                <div className=''>
                    {this.props.data && this.props.data['**stage'] ?
                        (Array.isArray(this.state.available) && this.state.available.map((element, index) => {
                            if (element.type != 'trigger') {
                                let isCurrent = this.props.data['**stage']?.value?.stage?.id == element.id
                                let backIsWhite = isWhite(element.color?.background)
                                return (
                                    <button key={index} className={"px-2 flexcb w-100  br-5 py-1 hover-gray-no-filter"} style={{}} onClick={() => this.changeRecordStage(element)}>
                                        <div className='flexc br-20 ' style={{ padding: '6px 12px', border: backIsWhite ? '1px solid #f6f6f6' : null, background: element.color?.background, color: element.color?.text }}>
                                            {/* <img className='toolbar-icon flexcc' width={18} src={importedIcons.stage} style={{ filter: this.props.currentRecordStage == element.id ? 'invert(100%)' : 'invert(0%)' }} /> */}
                                            <div>
                                                <p className="font-size-12  main-c3 text-start text-bold" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{checkTranslation(element.name)}</p>
                                            </div>
                                        </div>

                                        {isCurrent && (
                                            <p className='text-smaller px-1' style={{ color: '#aaa' }}>{translate("Current")}</p>
                                        )}
                                    </button>
                                )
                            }
                        })) : (
                            <div>
                                <p className='font-size-13 px-2 text-semibold' style={{ color: '#222' }}>{translate("There are no stages to show")}</p>
                            </div>
                        )}
                </div>
            </div>
        )
    }
}
